import { render, staticRenderFns } from "./ReportsMessagesBySite.vue?vue&type=template&id=3a82c126&"
import script from "./ReportsMessagesBySite.vue?vue&type=script&lang=js&"
export * from "./ReportsMessagesBySite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports